import { SimNaoEnum } from 'components/form'
import { MChatInput, MChatPerguntaEnum } from 'graphql/types.generated'
import { isEmpty } from 'lodash'
import { isUndefinedOrNull } from 'util/checks'

import { MChatQueryModel } from '../mchat/model-mchat'
import { getAplicacaoStats } from './consulta-seguimento-aplicacao/utils-consultaSeguimentoAplicacao'
import { ConsultaSeguimentoPerguntasMap } from './consultaSeguimentoPerguntasMap'
import {
  ConsultaSeguimentoFieldModel,
  ConsultaSeguimentoViewModel,
  MChatRiscoToConsultaSeguimentoResultado,
  PassouFalhouEnum,
  PodeNaoPodeEnum,
} from './model-consultaSeguimento'
import { getPerguntaPaiBySubPergunta } from './utils-consultaSeguimento'

export const convertConsultaSeguimentoToInput = (
  consultaSeguimento: ConsultaSeguimentoFieldModel
): MChatInput['aplicacaoMChatRf'] => {
  if (isEmpty(consultaSeguimento)) return null
  return Object.entries(consultaSeguimento.aplicacao).flatMap(([pergunta, resposta]) => {
    const { convertToInput } = ConsultaSeguimentoPerguntasMap[pergunta]
    return convertToInput(resposta)
  })
}

export const convertConsultaSeguimentoQueryToViewModel = (
  consultaSeguimento: MChatQueryModel
): ConsultaSeguimentoViewModel => {
  if (isEmpty(consultaSeguimento)) return null

  const perguntasPai = new Set<MChatPerguntaEnum>()
  const subPerguntas = consultaSeguimento.aplicacao.map((pergunta) => pergunta.pergunta)

  subPerguntas.forEach((subPergunta) => {
    const perguntaPai = getPerguntaPaiBySubPergunta(subPergunta)

    if (!perguntasPai.has(perguntaPai)) {
      perguntasPai.add(perguntaPai)
    }
  })

  const totalOfPerguntasRespondidas = perguntasPai.size
  const numberOfPerguntasFalhou = consultaSeguimento.pontuacao
  const numberOfPerguntasPassou = totalOfPerguntasRespondidas - numberOfPerguntasFalhou

  return {
    resultado: MChatRiscoToConsultaSeguimentoResultado[consultaSeguimento.risco],
    numberOfPerguntasFalhou,
    numberOfPerguntasPassou,
    totalOfPerguntasRespondidas,
    footerInfo: {
      dataResultado: consultaSeguimento?.dataResultado,
      lotacao: consultaSeguimento?.atendimentoProfissional?.lotacao,
      atendimentoProfissionalId: consultaSeguimento?.atendimentoProfissional?.id,
    },
  }
}

export const convertConsultaSeguimentoFieldToViewModel = (
  consultaSeguimento: ConsultaSeguimentoFieldModel
): ConsultaSeguimentoViewModel => {
  if (isEmpty(consultaSeguimento)) return null

  const { numberOfPerguntasFalhou, numberOfPerguntasPassou, totalOfPerguntasRespondidas } = getAplicacaoStats(
    consultaSeguimento.aplicacao
  )

  return {
    resultado: consultaSeguimento.resultado,
    numberOfPerguntasFalhou,
    numberOfPerguntasPassou,
    totalOfPerguntasRespondidas,
  }
}

export const convertSimNaoEnumToBoolean = (value: SimNaoEnum): boolean | null => {
  if (isUndefinedOrNull(value)) return null
  return value === SimNaoEnum.SIM
}

export const convertPodeNaoPodeEnumToBoolean = (value: PodeNaoPodeEnum): boolean | null => {
  if (isUndefinedOrNull(value)) return null
  return value === PodeNaoPodeEnum.PODE
}

export const convertPassouFalhouEnumToBoolean = (value: PassouFalhouEnum): boolean | null => {
  if (isUndefinedOrNull(value)) return null
  return value === PassouFalhouEnum.PASSOU
}
